import React from 'react'

export const ToggleIcon = ({...props}) => {
    return (
        <svg width="17" height="10" viewBox="0 0 17 10" fill="none" {...props}>
           	<path d="M17 9L9 0.999999L1 9" stroke="white" />
		</svg>
    )
}
